import i18n from 'src/i18n';

const mixinDialog = {
  computed: {
    getTitle() {
      if (this.title == null) {
        return i18n.t('common_words.record_selected_threepoints');
      } else {
        return this.title;
      }
    },
  },
  data() {
    return {
      title: null,
      modals: {
        read: false,
        create: false,
        delete: false,
        map: false,
      },
    };
  },

  methods: {
    openModal(name, disableField = false) {
      if (name == 'create') {
        this.title = disableField
          ? i18n.t('common_words.edit_selected_record')
          : i18n.t('common_words.create_new_record');
        this.errors.clear();
        this.$validator.reset();
        this.model = { ...this.initialModel };

        try {
          this.updateDisabledField(disableField);
        } catch (error) { }

        if (this.$refs.createDialog) {
          this.$refs.createDialog.modals[name] = true;
        } else this.modals[name] = true;
      } else this.modals[name] = true;
    },

    closeModal(name) {
      if (this.$refs.createDialog) {
        this.$refs.createDialog.modals[name] = false;
      } else this.modals[name] = false;
      setTimeout(() => {
        this.title = i18n.t('common_words.record_selected_threepoints');
      }, 300);

      try {
        this.fileList = [];
      } catch (error) { }
    },
  },
};

export default mixinDialog;
